import React, { useReducer } from 'react';
import reducer from './reducer/reducer';
import context from './context';

const ContextProvider = (props: any) => {
  const { children, value } = props;
  const [state, dispatch] = useReducer(reducer, { context, ...value });
  const data = Object.assign({ ...state, dispatch });

  return <context.Provider value={data}>{children}</context.Provider>;
};

ContextProvider.defaultProps = {
  children: <></>,
};

export default context;
export { ContextProvider, context };
